import { ApiRateLimitType, ForcedUpdateType } from 'src/shared/types/src';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: ApiRateLimitType = {
    isRateLimitActive: false,
    retryAfter: 0
}

const rateLimitSlice = createSlice({
    name: 'rateLimitSlice',
    initialState,
    reducers: {
        setRateLimitConfig: (state, action: PayloadAction<ApiRateLimitType>) => {
            const { isRateLimitActive, retryAfter } = action.payload;
            state.isRateLimitActive = isRateLimitActive;
            state.retryAfter = retryAfter;
        },
        resetRateLimitConfig: () => {
            return initialState;
        }
    }
});

export const RateLimitActions = rateLimitSlice.actions;
export default rateLimitSlice.reducer;
